import firebase from "firebase/app";

import { Card } from "semantic-ui-react";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import updateOrganization from "astrid-firestore/src/api/organizations/updateOrganization";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";

export default function OrganizationLanguageSettings({ organization }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		defaultValues: {
			languageDefault: organization.languageDefault || "",
			languageOptions: organization.languageOptions || [],
		},
		onSubmit: (data) => {
			return updateOrganization(firebase, organization.ref, data);
		},
	});

	const { watch, setValue, formState, onSubmit } = form;

	const data = watch();

	useEffect(() => {
		if (!data.languageOptions.includes(data.languageDefault)) {
			setValue("languageDefault", data.languageOptions[0] || "");
		}
	}, [data.languageDefault, data.languageOptions, setValue]);

	return (
		<Card fluid>
			<Card.Content>
				<Form form={form}>
					<Form.Group widths="equal">
						<Form.LanguageSelect
							name="languageOptions"
							label={t("languageOptions")}
							multiple
							rules={{ required: false }}
						/>

						<Form.LanguageSelect
							name="languageDefault"
							label={t("languageDefault")}
							limitedOptions={data.languageOptions}
							rules={{ required: false }}
						/>
					</Form.Group>
				</Form>
			</Card.Content>

			<Card.Content>
				<PrimaryButton
					disabled={formState.isSubmitting || !formState.isDirty}
					loading={formState.isSubmitting}
					onClick={onSubmit}
				>
					{t("save", "Save")}
				</PrimaryButton>
			</Card.Content>
		</Card>
	);
}
